/**
 * Pure privacy-default logic, extracted from the SDK class so the masking
 * defaults can be unit-tested (and mutation-tested) without a DOM or the rrweb
 * recorder, in the same spirit as sessionLifecycle.ts.
 */

/**
 * Resolve rrweb's `maskInputOptions.password`.
 *
 * rrweb masks password inputs BY DEFAULT: in the bundled record.js, when the
 * `maskInputOptions` object is `undefined` it falls back to `{ password: true }`.
 * But the SDK's config merge always produced a fully-populated object with
 * `password` computed as `!!(server.password || client.password)`, so when
 * neither side set it the value was an explicit `false`. Because the merged
 * object is always defined, rrweb's `{ password: true }` fallback never ran, and
 * a property that configured nothing got WEAKER protection than plain rrweb:
 * password inputs were captured in the replay.
 *
 * This restores the safe default: a password input is masked unless a side
 * EXPLICITLY opts out with `password: false`. An explicit `true` on either side
 * always masks; when neither side says anything, we mask (rrweb's own default).
 */
export function resolvePasswordMask(
  serverPassword: boolean | undefined,
  clientPassword: boolean | undefined
): boolean {
  if (serverPassword === true || clientPassword === true) return true;
  if (serverPassword === false || clientPassword === false) return false;
  return true;
}
